'use client'
import useCartStore from '@/store/cartStore'
import useWishListStore from '@/store/wishListStore'
import { useRouter, useSearchParams } from 'next/navigation'
import { useState, useEffect } from 'react'
import MobileSearchBar from './MobileSearchBar'
import useCommonStore from '@/store/commonStore'
import Image from 'next/image'


export default function CommonHeader({
  showSearch = true,
  showCart = true,
  title,
  showBack = true,
  showHeart = true,
  onBack,
  backPath,
  style
}: {
  showSearch?: boolean
  showCart?: boolean
  title?: string
  showBack?: boolean
  showHeart?: boolean
  onBack?: () => void
  backPath?: string
  style?: string
}) {
  const searchParams = useSearchParams()

  const router = useRouter()
  const [isShowSearch, setShowSearch] = useState(false)
  const { translations } = useCommonStore()
  const headerTitle = translations[`${title}`] || title
  const headerStyle = style
  const { cart } = useCartStore()
  const { wishList } = useWishListStore()
  let redirect = searchParams.get("redirect")
  const handleBack = () => {
    if (onBack) {
      onBack()
      return
    }
    if (redirect) {
      router.push(redirect)
    } else if (backPath) {
      router.push(backPath)
    } else {
      router.back()
    }
  }

  return (
    <>
      <div className={`${headerStyle} bg-white flex justify-between items-center max-w-7xl mx-auto p-4 md:py-6 md:px-0`}>
        <div className="flex items-center gap-2">
          {showBack && (
            <button onClick={handleBack} aria-label="Back" className='rtl:rotate-180'>
              <Image src={"/back-arrow.svg"} alt="back" width={18} height={18} />
            </button>
          )}
          <h2 className="font-bold text-lg">{headerTitle}</h2>
        </div>
        <div className="flex items-center gap-5">
          {showSearch && (
            <button onClick={() => setShowSearch(true)}>
              <img src={`${process.env.NEXT_PUBLIC_ICON_URL}9b199114-f6d9-44aa-a456-7927f715a975.svg`} alt="Icon" className="w-5 h-5" />
            </button>
          )}
          {showHeart && (
            <a href="/profile?tab=wishlist" className='relative'>
              <img
                src={`${process.env.NEXT_PUBLIC_ICON_URL}9b871b36-dcdc-4f70-a107-7e9199484a38.svg`}
                alt="wishlist"
                className="w-5 h-5"
              />
              {wishList?.length > 0 && (
                <span className="absolute top-0 right-0 bg-red-500 text-white text-xs rounded-full px-1 py-1"></span>
              )}
            </a>
          )}
          {showCart && (
            <a href="/mycart" className="relative">
              <img src={`${process.env.NEXT_PUBLIC_ICON_URL}3c17c865-3652-49af-9125-defed82e01db.svg`} alt="cart icon" className="w-5 h-5" />
              {cart?.length > 0 && (
                <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full min-w-[14px] h-[14px] flex items-center justify-center text-[10px]">
                  {cart?.length}
                </span>
              )}
            </a>
          )}
        </div>
      </div>
      {isShowSearch && (
        <MobileSearchBar showSearch={isShowSearch} onClose={() => setShowSearch(false)} />
      )}
    </>
  )
}